'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = require('scrollmonitor');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scrollmonitor/build/scrollMonitorClient.js
 ** module id = 800
 ** module chunks = 0
 **/